import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
import { ExActions, ExMutations } from "@/exstore/ExStoreEnums";
import ExApiService from "@/excore/ExApiService";
import { ErrorPopup } from "@/excore/Popup";

export interface Notifications {
  notifications: NotificationModel[];
}
interface NotificationModel {
  message: string;
  redirect_url: string;
  created_at: string;
}
@Module
export default class ExSepetModule extends VuexModule {
  notifications = { notifications: [] } as Notifications;

  get currentNotifications(): Notifications {
    return this.notifications;
  }
  @Mutation
  [ExMutations.SET_NOTIF](data) {
    this.notifications.notifications = data;
  }
  @Action
  async [ExActions.READ_NOTIF](id) {
    if (this.context.getters.isUserAuthenticated !== true) {
      return;
    }
    const [error, data] = await ExApiService.put("notification?columns=id&column_types=80&query=" + id, {
      is_read: true,
    });
    if (error) {
      ErrorPopup(error);
      return;
    }
    await this.context.dispatch(ExActions.UPDATE_NOTIF);
  }
  @Action
  async [ExActions.UPDATE_NOTIF]() {
    if (this.context.getters.isUserAuthenticated !== true) {
      return;
    }
    const [error, data] = await ExApiService.get(
      "notifications-me?sort_columns=created_at&sort_column_types=1&sort_orders=desc"
    );
    if (error) {
      ErrorPopup(error);
      return;
    }
    this.context.commit(ExMutations.SET_NOTIF, data.data);
  }
}
